import gql from 'graphql-tag'

export const PUT_INSTRUCTOR = gql`
  mutation PutInstructor($putInstructorsInput: [PutInstructorsInput!]!) {
    putInstructors(putInstructorsInput: $putInstructorsInput) {
      Success
    }
  }
`
